export default {
  'sod.ttl.define.matrix': {
    ko: 'SoD 매트릭스 정의',
    en: 'Define SoD Matrix',
    cn: 'Define SoD Matrix',
    ja: 'Define SoD Matrix',
  },
  'sod.ttl.define.ra.auth': {
    ko: 'RA 권한 정의',
    en: 'Define RA Authority',
    cn: 'Define RA Authority',
    ja: 'Define RA Authority',
  },
  'sod.ttl.dashboard': {
    ko: '대시보드',
    en: 'Dashboard',
    cn: 'Dashboard',
    ja: 'Dashboard',
  },
  'sod.ttl.matrix': {
    ko: 'SoD 매트릭스',
    en: 'SoD Matrix',
    cn: 'SoD Matrix',
    ja: 'SoD Matrix',
  },
  'sod.filter.matrix.nm': {
    ko: "SoD 매트릭스 명 입력 ('%' 허용)",
    en: "Enter a SoD matrix name... (with '%')",
    cn: "Enter a SoD matrix name... (with '%')",
    ja: "Enter a SoD matrix name... (with '%')",
  },
  'sod.ttl.id': {
    ko: 'ID.',
    en: 'ID.',
    cn: 'ID.',
    ja: 'ID.',
  },
  'sod.ttl.nm': {
    ko: '명',
    en: 'Name',
    cn: 'Name',
    ja: 'Name',
  },
  'sod.ttl.desc': {
    ko: '설명',
    en: 'Description',
    cn: 'Description',
    ja: 'Description',
  },
  'sod.ttl.risk.level': {
    ko: '위험 수준',
    en: 'Risk level',
    cn: 'Risk level',
    ja: 'Risk level',
  },
  'sod.ttl.duty': {
    ko: '직무',
    en: 'Duty',
    cn: 'Duty',
    ja: 'Duty',
  },
  'sod.ttl.row.duty': {
    ko: '직무 (행)',
    en: 'Duty (Row)',
    cn: 'Duty (Row)',
    ja: 'Duty (Row)',
  },
  'sod.ttl.col.duty': {
    ko: '직무 (열)',
    en: 'Duty (Column)',
    cn: 'Duty (Column)',
    ja: 'Duty (Column)',
  },
  'sod.ttl.row.duty.auth': {
    ko: '직무 (행) 권한',
    en: 'Duty (Row) Authority',
    cn: 'Duty (Row) Authority',
    ja: 'Duty (Row) Authority',
  },
  'sod.ttl.col.duty.auth': {
    ko: '직무 (열) 권한',
    en: 'Duty (Column) Authority',
    cn: 'Duty (Column) Authority',
    ja: 'Duty (Column) Authority',
  },
  'sod.ttl.is.active': {
    ko: '활성화 여부',
    en: 'Is active ?',
    cn: 'Is active ?',
    ja: 'Is active ?',
  },
  'sod.ttl.auth': {
    ko: '권한',
    en: 'Authority',
    cn: 'Authority',
    ja: 'Authority',
  },
  'sod.ttl.auth.obj': {
    ko: '권한객체',
    en: 'Object',
    cn: 'Object',
    ja: 'Object',
  },
  'sod.ttl.auth.fld': {
    ko: '필드',
    en: 'Field',
    cn: 'Field',
    ja: 'Field',
  },
  'sod.ttl.auth.val': {
    ko: '값',
    en: 'Value',
    cn: 'Value',
    ja: 'Value',
  },
  'sod.ph.duty.nm': {
    ko: '직무명 입력',
    en: 'Enter a duty name',
    cn: 'Enter a duty name',
    ja: 'Enter a duty name',
  },
  'sod.ph.auth.obj': {
    ko: '권한객체 입력',
    en: 'Enter a authorization object',
    cn: 'Enter a authorization object',
    ja: 'Enter a authorization object',
  },
  'sod.filter.duty.nm': {
    ko: "직무명 입력 ('%' 허용)",
    en: "Enter a duty name... (with '%')",
    cn: "Enter a duty name... (with '%')",
    ja: "Enter a duty name... (with '%')",
  },
  'sod.risk.level.L': {
    ko: '낮음',
    en: 'Low',
    cn: 'Low',
    ja: 'Low',
  },
  'sod.risk.level.M': {
    ko: '중간',
    en: 'Medium',
    cn: 'Medium',
    ja: 'Medium',
  },
  'sod.risk.level.H': {
    ko: '높음',
    en: 'High',
    cn: 'High',
    ja: 'High',
  },
  'sod.risk.level.C': {
    ko: '치명적',
    en: 'Critical',
    cn: 'Critical',
    ja: 'Critical',
  },
  'sod.ttl.ra': {
    ko: '접근제한',
    en: 'Restricted acess',
    cn: 'Restricted acess',
    ja: 'Restricted acess',
  },
  'sod.ttl.ra.auth': {
    ko: '접근제한 권한',
    en: 'Restricted authority',
    cn: 'Restricted authority',
    ja: 'Restricted authority',
  },
  'sod.ttl.risk.type': {
    ko: '위험 유형',
    en: 'Risk type',
    cn: 'Risk type',
    ja: 'Risk type',
  },
  'sod.risk.type.A': {
    ko: '권한객체',
    en: 'Auth. Object',
    cn: 'Auth. Object',
    ja: 'Auth. Object',
  },
  'sod.risk.type.P': {
    ko: '프로파일',
    en: 'Profile',
    cn: 'Profile',
    ja: 'Profile',
  },
  'sod.ttl.prfl': {
    ko: '프로파일',
    en: 'Profile',
    cn: 'Profile',
    ja: 'Profile',
  },
  'sod.ph.prfl': {
    ko: '프로파일 입력',
    en: 'Enter a profile',
    cn: 'Enter a profile',
    ja: 'Enter a profile',
  },
  'sod.filter.ra.nm': {
    ko: "접근제한 명 입력 ('%' 허용)",
    en: "Enter a RA name... (with '%')",
    cn: "Enter a RA name... (with '%')",
    ja: "Enter a RA name... (with '%')",
  },
  'sod.ttl.analyze.form': {
    ko: 'SoD/RA 분석을 위한 조건 입력 및 분석 시작',
    en: 'Input condition for analyzing SoD/Ra and analyze',
    cn: 'Input condition for analyzing SoD/Ra and analyze',
    ja: 'Input condition for analyzing SoD/Ra and analyze',
  },
  'sod.msg.is.running': {
    ko: '현재 분석 작업이 진행 중입니다.',
    en: 'Analyzing job is running...',
    cn: 'Analyzing job is running...',
    ja: 'Analyzing job is running...',
  },
  'sod.msg.is.erasing': {
    ko: '이미 삭제 중입니다.',
    en: 'Deleting job is running...',
    cn: 'Deleting job is running...',
    ja: 'すでに削除中です。',
  },
  'sod.confirm.delete': {
    ko: '선택된 분석결과가 모두 삭제됩니다. 삭제하시겠습니까?',
    en: 'All data in selected analyzing result will be erased. Would you like to delete?.',
    cn: 'All data in selected analyzing result will be erased. Would you like to delete?.',
    ja: 'All data in selected analyzing result will be erased. Would you like to delete?.',
  },
  'sod.confirm.stop': {
    ko: '선택된 진행중인 분석 작업을 중단하시겠습니까?',
    en: 'Would you like to stop the selected analyzing job?',
    cn: 'Would you like to stop the selected analyzing job?',
    ja: 'Would you like to stop the selected analyzing job?',
  },
  'sod.msg.stopped': {
    ko: '분석 작업이 중단되었습니다.',
    en: 'The batch process for analyzing was aborted.',
    cn: 'The batch process for analyzing was aborted.',
    ja: 'The batch process for analyzing was aborted.',
  },
  'sod.confirm.analyze': {
    ko: 'SoD/RA 분석 작업에는 몇십분 정도의 시간이 소요됩니다. 분석하시겠습니까?',
    en: 'It will be take a few ten minutes of time. Would you like to start analyzing the SoD/RA?',
    cn: 'It will be take a few ten minutes of time. Would you like to start analyzing the SoD/RA?',
    ja: 'It will be take a few ten minutes of time. Would you like to start analyzing the SoD/RA?',
  },
  'sod.stop': {
    ko: '분석 중지',
    en: 'Stop',
    cn: 'Stop',
    ja: 'Stop',
  },
  'sod.delete': {
    ko: '선택 내역 삭제',
    ja: '選択項目を削除',
    en: 'Delete selected',
    cn: 'Delete selected',
  },
  'sod.system': {
    ko: '시스템',
    en: 'System',
    cn: 'System',
    ja: 'System',
  },
  'sod.rtrck.datetime': {
    ko: '데이터 셋',
    en: 'Data set',
    cn: 'Data set',
    ja: 'Data set',
  },
  'sod.anal.mandt': {
    ko: 'Client No.',
    en: 'Client No.',
    cn: 'Client No.',
    ja: 'Client No.',
  },
  'sod.anal.type': {
    ko: '분석 구분',
    en: 'Analyze type',
    cn: 'Analyze type',
    ja: 'Analyze type',
  },
  'sod.anal.datetime': {
    ko: '분석 일시',
    en: 'Analyzed datetime',
    cn: 'Analyzed datetime',
    ja: 'Analyzed datetime',
  },
  'sod.exec.type': {
    ko: '구분',
    en: 'Type',
    cn: 'Type',
    ja: 'Type',
  },
  'sod.exec.status': {
    ko: '상태',
    en: 'Status',
    cn: 'Status',
    ja: 'Status',
  },
  'sod.exec.rate': {
    ko: '진행률',
    en: 'Exec. rate',
    cn: 'Exec. rate',
    ja: 'Exec. rate',
  },
  'sod.anal.desc': {
    ko: '설명',
    en: 'Description',
    cn: 'Description',
    ja: 'Description',
  },
  'sod.anal.reason': {
    ko: '분석 사유',
    en: 'Reason for analyzing',
    cn: 'Reason for analyzing',
    ja: 'Reason for analyzing',
  },
  'sod.ex.msg': {
    ko: '에러 메시지',
    en: 'Error message',
    cn: 'Error message',
    ja: 'Error message',
  },
  'sod.anal.type.A': {
    ko: 'SoD & RA',
    en: 'SoD & RA',
    cn: 'SoD & RA',
    ja: 'SoD & RA',
  },
  'sod.anal.type.S': {
    ko: 'SoD',
    en: 'SoD',
    cn: 'SoD',
    ja: 'SoD',
  },
  'sod.anal.type.R': {
    ko: 'RA',
    en: 'RA',
    cn: 'RA',
    ja: 'RA',
  },
  'sod.msg.invalid.auth.val': {
    ko: "(권한) 값은 '*' 또는 '%'를 포함할 수 없습니다.",
    en: "'*' or '%' is not able to be included in (Auth.) val.",
    cn: "'*' or '%' is not able to be included in (Auth.) val.",
    ja: "'*' or '%' is not able to be included in (Auth.) val.",
  },
  'sod.exec.type.1': {
    ko: '분석',
    en: 'Analyze',
    cn: 'Analyze',
    ja: 'Analyze',
  },
  'sod.exec.type.2': {
    ko: '삭제',
    en: 'Delete',
    cn: 'Delete',
    ja: 'Delete',
  },
  'sod.target.role': {
    ko: '분석대상 Role',
    en: 'Role targeted',
    cn: 'Role targeted',
    ja: 'Role targeted',
  },
  'sod.only.generated': {
    ko: 'Profile generate된 것만',
    en: 'Only profile generated',
    cn: 'Only profile generated',
    ja: 'Only profile generated',
  },
  'sod.only.compared': {
    ko: 'User comparison된 것만',
    en: 'Only user compared',
    cn: 'Only user compared',
    ja: 'Only user compared',
  },
  'sod.anal.set': {
    ko: '분석 결과',
    en: 'Analyzed result',
    cn: 'Analyzed result',
    ja: 'Analyzed result',
  },
  'sod.msg.no.dataset': {
    ko: '해당 시스템의 분석된 결과가 존재하지 않습니다. 먼저 분석을 진행해 주십시오.',
    en: 'No result analyzed for selected system. Please, do analyze job, first.',
    cn: 'No result analyzed for selected system. Please, do analyze job, first.',
    ja: 'No result analyzed for selected system. Please, do analyze job, first.',
  },
  'sod.anal.rslt.stts': {
    ko: '분석 결과 통계',
    en: 'Statistics of analyzed result',
    cn: 'Statistics of analyzed result',
    ja: 'Statistics of analyzed result',
  },
  'sod.anal.rslt.detail': {
    ko: '분석 결과 상셰',
    en: 'Details of analyzed result',
    cn: 'Details of analyzed result',
    ja: 'Details of analyzed result',
  },
  'sod.anal.general.info': {
    ko: '일반 정보',
    en: 'General information',
    cn: 'General information',
    ja: 'General information',
  },
  'sod.anal.ymdhms': {
    ko: '분석 일시',
    en: 'Datetime analyzed',
    cn: 'Datetime analyzed',
    ja: 'Datetime analyzed',
  },
  'sod.target.sstm': {
    ko: '대상 시스템',
    en: 'System targeted',
    cn: 'System targeted',
    ja: 'System targeted',
  },
  'sod.target.mandt': {
    ko: '대상 Client No.',
    en: 'Client No. targeted',
    cn: 'Client No. targeted',
    ja: 'Client No. targeted',
  },
  'sod.anal.stts.info': {
    ko: '통계 정보',
    en: 'Statistical information',
    cn: 'Statistical information',
    ja: 'Statistical information',
  },
  'sod.tot.vltn.cnt': {
    ko: '총 위배 건수',
    en: 'Total violation',
    cn: 'Total violation',
    ja: 'Total violation',
  },
  'sod.ttl.sod.vltn': {
    ko: '직무 분리 위배',
    en: 'Violation of segreration of duty',
    cn: 'Violation of segreration of duty',
    ja: 'Violation of segreration of duty',
  },
  'sod.ttl.ra.vltn': {
    ko: '접근 제한 위배',
    en: 'Violation of restircted access',
    cn: 'Violation of restircted access',
    ja: 'Violation of restircted access',
  },
  'sod.msg.no.vltn': {
    ko: '위배 사항이 없습니다.',
    en: 'There is not a violation item.',
    cn: 'There is not a violation item.',
    ja: 'There is not a violation item.',
  },
  'sod.ttl.profile': {
    ko: 'Profile',
    en: 'Profile',
    cn: 'Profile',
    ja: 'プロファイル',
  },
};
